export const SIDEBAR_SELECTED_BACKGROUND = 'rgba(25, 118, 210, 0.2)';
